/* eslint-disable @typescript-eslint/no-explicit-any */
import { executeApiCall } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';
import { SuccessData } from 'types/api';
import { ProjectFile } from '../types';
import { uploadMutations } from 'entities/modules/uploads';
import { ExecuteUploadParams } from 'entities/modules/uploads/mutations';

export const projectFilesMutations = getMutations({
  addFileToProject: {
    action: async ({
      file,
      onUploadProgress,
      name,
      project,
    }: {
      file: File;
      name: string;
      project: string;
      onUploadProgress?: ExecuteUploadParams['onUploadProgress'];
    }): Promise<ProjectFile> => {
      const { url } = await uploadMutations.uploadFile.action({
        file,
        onUploadProgress,
        prefix: `projects/${project}`,
      });

      return executeApiCall({
        path: '/projects/files',

        payload: {
          project,
          file: {
            url,
            name,
            filename: file.name,
            contentType: file.type,
          },
        },
      });
    },

    messages: {
      suppressSuccess: true,
    },
  },

  swapProjectFileToTask: {
    action: async ({
      fileId,
      task,
      ...params
    }: {
      fileId: string;
      task: string;
      project: string;
    }): Promise<SuccessData> => {
      return executeApiCall({
        path: '/projects/file-swap',

        payload: {
          ...params,

          swaps: {
            [fileId]: task,
          },
        },
      });
    },

    messages: {
      success: (t) => ({
        title: t('files-swaped'),
        type: 'success',
      }),

      error: (t) => ({
        title: t('fail-to-swap-files'),
        description: t('try-again-in-a-few-moments') as string,
        type: 'error',
      }),
    },
  },

  renameProjectFile: {
    action: async (payload: {
      projectId: string;
      fileId: string;
      name: string;
    }): Promise<SuccessData> => {
      return executeApiCall({
        method: 'post',
        path: 'projects/files/rename',

        payload,
      });
    },
  },

  newProjectFileVersion: {
    action: async ({
      file,
      name,
      ...params
    }: {
      projectId: string;
      taskId: string;
      fileId: string;
      name: string;
      file: File;
    }): Promise<ProjectFile> => {
      const { url } = await uploadMutations.uploadFile.action({
        file,
        prefix: `projects/${params.projectId}`,
      });

      return executeApiCall({
        method: 'post',
        path: 'projects/files/version',

        payload: {
          ...params,

          file: {
            url,
            filename: file.name,
            contentType: file.type,
            name,
          },
        },
      });
    },
  },
});
